import { Component, input } from '@angular/core';

import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';

@Component({
  selector: 'app-kiosk-header-block',
  templateUrl: './kiosk-header-block.component.html',
})
export class KioskHeaderBlockComponent {
  readonly color = input<string>();
  readonly displayLogo = input(false);
  readonly logo = input<{
    url: IContentBuilderFieldImage;
  }>();
  readonly backgroundColor = input<IContentBuilderFieldColor>();
  readonly backgroundImage = input<IContentBuilderFieldImage>();
  readonly headerLandingText = input<string>();
  readonly displayHomeButton = input<boolean>(false);
  readonly displayLeavingSessionButton = input<boolean>(false);
  readonly buttonHomeText = input<string>();
  readonly buttonBackgroundColor = input<IContentBuilderFieldColor>();
  readonly buttonTextColor = input<IContentBuilderFieldColor>();
  readonly size = input<'L' | 'M' | 'S'>('S');
}
